import { Inject, Injectable } from '@angular/core';
import { Settings } from '../models/settings.model';
import { ApiService } from '../../../shared/services/api.service';
import { API_BASE_URL } from '../../../shared/tokens/api.tokens';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ErrorHandlerService } from '../../../shared/services/error-handler.service';
import { ResultSet } from '../../../shared/models/result-set.model';
import { catchError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettingsService extends ApiService<Settings> {

  override searchFields: string[] = [];
  override _baseUrl: string;

  constructor(@Inject(API_BASE_URL) apiBaseUrl: string, http: HttpClient, errorHandler: ErrorHandlerService) { 
    super(http, errorHandler);
    this._baseUrl = `${apiBaseUrl}settings/`;    
  }  

  override getAll(): Observable<ResultSet<Settings>> {
    throw new Error('Method not implemented.');
  }

  override get(): Observable<Settings> {
    return this.http.get<Settings>(`${this._baseUrl}`).pipe(
          catchError(this.handleError)
        );
  }

  override update(model: Settings): Observable<Settings> {
    return this.http.put<Settings>(`${this._baseUrl}`, model).pipe(
          catchError(this.handleError)
        );
  }

  override create(model: Settings): Observable<Settings> {
    throw new Error('Method not implemented.');
  }

  override delete(modelID: number): Observable<Object> {
    throw new Error('Method not implemented.');
  }

  override downloadCSV(): Observable<HttpResponse<Blob>> {
    throw new Error('Method not implemented.');        
  }
  
}
